import { useDeviceSessions, useRevokeSession } from '@numistic/data'
import { useTranslation } from '@numistic/i18n'
import { Alert, Badge, Button, Card, CardContent, CardHeader, CardTitle } from '@numistic/ui'
import { createRoute } from '@tanstack/react-router'

import { useErrorText } from '../../lib/errors.js'
import { describeUserAgent, formatDateTime } from '../../lib/format.js'
import { settingsRoute } from './layout.js'

export const devicesRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: 'devices',
  component: DevicesPage,
})

function DevicesPage() {
  const { t } = useTranslation()
  const errorText = useErrorText()
  const sessions = useDeviceSessions()
  const revoke = useRevokeSession()

  return (
    <Card className="max-w-2xl">
      <CardHeader>
        <CardTitle>{t('devices.title')}</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-3">
        {(sessions.error ?? revoke.error) ? (
          <Alert variant="destructive">{errorText.request(sessions.error ?? revoke.error)}</Alert>
        ) : null}
        {sessions.data?.length === 0 ? (
          <p className="text-sm text-muted-foreground">{t('devices.empty')}</p>
        ) : null}
        <ul className="divide-y">
          {sessions.data?.map((s) => (
            <li key={s.id} className="flex flex-wrap items-center gap-3 py-3">
              <div className="grid gap-0.5">
                <span className="text-sm font-medium">
                  {describeUserAgent(s.userAgent) ?? t('devices.unknownDevice')}
                  {s.current ? (
                    <Badge variant="primary" className="ml-2">
                      {t('devices.current')}
                    </Badge>
                  ) : null}
                </span>
                <span className="text-xs text-muted-foreground">
                  {t('devices.since', { date: formatDateTime(s.createdAt) })}
                  {s.ipAddress ? ` · ${s.ipAddress}` : ''}
                </span>
              </div>
              {!s.current ? (
                <Button
                  className="ml-auto"
                  variant="outline"
                  size="sm"
                  disabled={revoke.isPending}
                  onClick={() => revoke.mutate(s.token)}
                >
                  {t('devices.revoke')}
                </Button>
              ) : null}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  )
}
